module.exports = __webpack_public_path__ + "static/media/ApercuPro-Bold.9eb0c779.woff2";